import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store';
import Home from '../views/Home.vue'
import { getToken } from '../js/tool'
import { trackEvent, EVENT_CODE } from '../js/analytics'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/home'
  },
  {
    path: '/home',
    name: 'Home',
    meta: {
      title: "泛亚人力",
      eventCode: EVENT_CODE.HOME_PAGE_VIEW
    },
    component: Home
  },
  {
    path: '/Login', // 登录页
    name: 'Login',
    meta: {
      title: "泛亚人力-请登录"
    },
    component: () => import('../views/user/Login.vue')
  },
  {
    path: '/User', // 我的账号
    name: 'User',
    meta: {
      title: "我的账号",
      eventCode: EVENT_CODE.PAGE_PERSONAL_CENTER
    },
    component: () => import('../views/user/User.vue')
  },
  {
    path: '/UserInfo', // 我的信息
    name: 'UserInfo',
    meta: {
      title: "我的信息",
      eventCode: EVENT_CODE.PAGE_PERSONAL_CENTER
    },
    component: () => import('../views/user/UserInfo.vue')
  },
  {
    path: '/EmployeeInfo', // 员工信息
    name: 'EmployeeInfo',
    meta: {
      title: "员工信息",
      eventCode: EVENT_CODE.EMPLOYEE_INFO_VIEW
    },
    component: () => import(/* webpackChunkName: "about" */ '../views/EmployeeInfo.vue')
  },
  {
    path: '/EmployeeInfo/:id', // 员工信息-详情
    name: 'EmployeeInfoItem',
    meta: {
      title: "员工信息-详情",
      hignlightNavPath: '/EmployeeInfo',
      eventCode: EVENT_CODE.EMPLOYEE_INFO_VIEW
    },
    component: () => import(/* webpackChunkName: "about" */ '../views/EmployeeInfoItem.vue')
  },
  {
    path: '/EmployeeContract', // 员工合同
    name: 'EmployeeContract',
    meta: {
      title: "员工合同",
      eventCode: EVENT_CODE.EMPLOYEE_CONTRACT_VIEW
    },
    component: () => import('../views/EmployeeContract.vue')
  },
  {
    path: '/EmployeeContract/:id', // 员工合同-详情
    name: 'EmployeeContractItem',
    meta: {
      title: "员工合同-详情",
      hignlightNavPath: '/EmployeeContract',
      eventCode: EVENT_CODE.EMPLOYEE_CONTRACT_VIEW
    },
    component: () => import(/* webpackChunkName: "about" */ '../views/EmployeeContractItem.vue')
  },
  {
    path: '/SocialSecurity', // 社保公积金
    name: 'SocialSecurity',
    meta: {
      title: "社保公积金",
      eventCode: EVENT_CODE.SOCIAL_SECURITY_VIEW
    },
    component: () => import('../views/SocialSecurity.vue')
  },
  {
    path: '/SocialSecurity/:id', // 社保公积金-详情
    name: 'SocialSecurityItem',
    meta: {
      title: " 社保公积金-详情",
      hignlightNavPath: '/SocialSecurity',
      eventCode: EVENT_CODE.SOCIAL_SECURITY_VIEW
    },
    component: () => import('../views/SocialSecurityItem.vue')
  },
  {
    path: '/SalaryBatches', // 薪资批次
    name: 'SalaryBatches',
    meta: {
      title: "薪资批次",
      eventCode: EVENT_CODE.SALARY_BATCH_VIEW
    },
    component: () => import('../views/SalaryBatches.vue')
  },
  {
    path: '/SalaryBatches/:salarySummaryId', // 薪资批次-详情
    name: 'SalaryBatchesItem',
    meta: {
      title: "薪资批次-详情",
      hignlightNavPath: '/SalaryBatches',
      eventCode: EVENT_CODE.SALARY_BATCH_DETAIL_VIEW
    },
    component: () => import('../views/SalaryBatchesItem.vue')
  },
  {
    path: '/SalaryDetails', // 薪资详情
    name: 'SalaryDetails',
    meta: {
      title: "薪资详情",
      eventCode: EVENT_CODE.SALARY_BATCH_DETAIL_LIST_VIEW
    },
    component: () => import('../views/SalaryDetails.vue')
  },
  {
    path: '/SalaryDetails/:pkid', // 薪资详情-详情
    name: 'SalaryDetailsItem',
    meta: {
      title: "薪资详情",
      hignlightNavPath: '/SalaryDetails',
      eventCode: EVENT_CODE.SALARY_BATCH_DETAIL_DETAIL_VIEW
    },
    component: () => import('../views/SalaryDetailsItem.vue')
  },
  {
    path: '/EmploymentData', // 用工数据
    name: 'EmploymentData',
    meta: {
      title: "用工数据",
      eventCode: EVENT_CODE.EMPLOYMENT_DATA_VIEW
    },
    component: () => import('../views/EmploymentData.vue') 
  },
  {
    path: '/SocialSecurityData', // 社保数据
    name: 'SocialSecurityData',
    meta: {
      title: "社保数据",
      eventCode: EVENT_CODE.SOCIAL_SECURITY_DATA_VIEW
    },
    component: () => import('../views/SocialSecurityData.vue')
  },
  {
    path: '/SalaryData', // 薪酬数据
    name: 'SalaryData',
    meta: {
      title: "薪酬数据",
      eventCode: EVENT_CODE.SALARY_DATA_VIEW
    },
    component: () => import('../views/SalaryData.vue')
  },
  {
    path: '/Message/', // 通知提醒
    name: 'Message',
    meta: {
      title: "通知提醒",
      eventCode: EVENT_CODE.MESSAGE_NOTIFICATION_VIEW
    },
    component: () => import('../views/Message.vue')
  },
  {
    path: '/MessageItem/:id', // 通知提醒-详情
    name: 'MessageItem',
    meta: {
      title: "通知提醒-详情",
      hignlightNavPath: '/Message',
      eventCode: EVENT_CODE.MESSAGE_NOTIFICATION_DETAIL
    },
    component: () => import('../views/MessageItem.vue')
  },
  {
    path: '/MessageSettings', // 通知提醒设置
    name: 'MessageSettings',
    meta: {
      title: "通知提醒设置",
      eventCode: EVENT_CODE.MESSAGE_NOTIFICATION_VIEW
    },
    component: () => import('../views/MessageSettings.vue')
  },
  {
    path: '/Policy', // 政策公告
    name: 'Policy',
    meta: {
      title: "政策公告",
      eventCode: EVENT_CODE.POLICY_NOTICE_VIEW
    },
    component: () => import('../views/Policy.vue')
  },
  {
    path: '/TimeLine', // 系统更新时间线
    name: 'TimeLine',
    meta: {
      title: "系统更新时间线"
    },
    component: () => import('../views/TimeLine.vue')
  },
  {
    path: '/Redirect', // 重定向页面
    name: 'Redirect',
    meta: {
      title: ""
    },
    component: () => import('../views/Redirect.vue')
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

// 路由守卫
router.beforeEach((to, from, next) => {
  console.log('[路由守卫] 开始执行')
  console.log('[路由守卫] to:', to)
  console.log('[路由守卫] from:', from)
  
  // 判断是否在iframe中
  const isInIframe = window.parent !== window
  console.log('[路由守卫] 是否在iframe中:', isInIframe)
  
  // 如果URL中有token参数，先保存到localStorage并更新store
  if (to.query.token) {
    console.log('[路由守卫] 检测到URL中的token，保存到localStorage并更新store')
    localStorage.setItem('token', to.query.token)
    // 更新store的登录状态
    store.commit('login', {
      user_name: localStorage.getItem('user_name') || '',
      server_name: localStorage.getItem('server_name') || '',
      server_phone: localStorage.getItem('server_phone') || '',
      server_mobilephone: localStorage.getItem('server_mobilephone') || '',
      server_email: localStorage.getItem('server_email') || '',
      tenant_id: localStorage.getItem('tenant_id') || '',
      tenant_name: localStorage.getItem('tenant_name') || ''
    })
  }
  
  store.commit('routeChange', {route: to});
  
  console.log('[路由守卫] getToken():', getToken())
  
  // 如果不在iframe中，当前是Redirect页面，直接重定向到Home
  if (!isInIframe && to.name === "Redirect") {
    console.log('[路由守卫] 当前是Redirect页面，重定向到Home')
    next({name: "Home"})
    return
  }
  
  // 在iframe中，只能访问Login页面
  if (isInIframe) {
    if (to.name !== "Login") {
      console.log('[路由守卫] 在iframe中，重定向到Login页面')
      next({name: "Login"})
      return
    }
    // 在iframe中且是Login页面，允许访问
    console.log('[路由守卫] 在iframe中访问Login页面，允许访问')
    next();
    return
  }
  
  // 正常的路由守卫逻辑（不在iframe中）
  if (to.name !== "Login" && !getToken()) {
    console.log('[路由守卫] 条件满足，跳转到Login')
    store.commit('logout');    
    next({name: "Login"});
  }else {
    console.log('[路由守卫] 允许访问')
    next();
  }
})

router.afterEach((to) => {
  if (to.meta.eventCode) {
    trackEvent(to.meta.eventCode, {
      path: to.path,
      name: to.name,
      timestamp: Date.now()
    });
  }
  
  if (window.parent !== window) {
    window.parent.postMessage({
      action: 'navigate',
      url: window.location.href
    }, '*')
    
    console.log('已向父项目发送导航消息:', window.location.href)
  }
})

export default router
